<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="dialogVisible"
      size="50%"
      :close-on-press-escape="false"
      :wrapperClosable="false"
    >
      <!-- <div style="margin-bottom: 10px">
      <el-steps :active="step" process-status="process" align-center="center">
        <el-step title="选择供应商"></el-step>
        <el-step title="选择设备分类"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div> -->
      <div
        v-if="step == 1"
        style="
          height: calc(100% - 60px);
          overflow-y: auto;
          overflow-x: hidden;
          box-sizing: border-box;
          padding: 20px;
        "
        v-loading="loading"
      >
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
          label-position="left"
          :rules="rules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="供应商编号" prop="cVenCode">
                <el-input
                  v-model="form.cVenCode"
                  disabled
                  placeholder="系统自动生成"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商名称" prop="cVenName">
                <div style="display: flex; align-items: center">
                  <el-input v-model="form.cVenName" style="flex: 1"> </el-input>
                  <el-button
                    type="primary"
                    @click="handleIconClick"
                    :disabled="title === '编辑供应商'"
                    icon="el-icon-search"
                  >
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="联系人" prop="cVenPerson">
                <el-input v-model="form.cVenPerson"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="cVenPhone">
                <el-input v-model="form.cVenPhone" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="供应商类型" prop="SupplierClassificationId">
                <el-select
                  v-model="form.SupplierClassificationId"
                  filterable
                  @change="SupplierClassificationIdChange"
                >
                  <el-option
                    v-for="item in SupplierClassificationList"
                    :key="item.Id"
                    :label="item.DicName"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="地址" prop="Address">
                <el-input v-model="form.Address" placeholder="地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="备注">
            <el-input
              v-model="form.Remarks"
              type="textarea"
              :autosize="{ minRows: 4 }"
            ></el-input>
          </el-form-item>
          <el-row>
            <el-divider content-position="left" class="divider"
              >需提交的资料：</el-divider
            >
            <el-row :gutter="20">
              <el-col :span="12" v-if="SupplierClassificationType == '1'">
                <el-form-item
                  label="项目资料类型"
                  prop="SupplierQualificationsList"
                >
                  <el-checkbox
                    :indeterminate="indeterminateA"
                    v-model="SupplierQualificationsAll"
                    @change="SupplierQualificationsAllChange"
                    >全选</el-checkbox
                  >

                  <el-checkbox-group
                    v-model="form.SupplierQualificationsList"
                    @change="SupplierQualificationsListChange"
                  >
                    <el-checkbox
                      v-for="item in SupplierQualificationsList"
                      :label="item.Id"
                      :key="item.Id"
                      style="width: 100%"
                      >{{ item.DicName }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="资质资料类型" prop="SupplierTypeList">
                  <el-checkbox
                    :indeterminate="indeterminateB"
                    v-model="SupplierTypeListAll"
                    @change="SupplierTypeListAllChange"
                    >全选</el-checkbox
                  >

                  <el-checkbox-group
                    v-model="form.SupplierTypeList"
                    @change="SupplierTypeListChange"
                  >
                    <el-checkbox
                      v-for="item in SupplierTypeList"
                      :label="item.Id"
                      :key="item.Id"
                      style="width: 100%"
                      >{{ item.DicName }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <!-- <el-form-item label="设备分类" required v-loading="treeLoading">
            <el-tree
              :data="TreeData"
              show-checkbox
              node-key="id"
              :default-expand-all="true"
              :props="defaultProps"
              ref="tree"
              @check-change="handleCheckChange"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  v-if="data.children && data.children.length > 0"
                  style="font-weight: 1000; font-size: 16px; color: #000"
                >
                  <i class="el-icon-s-grid" style="font-size: 18px"></i>&nbsp;{{
                    node.label
                  }}</span
                >
                <span v-if="!data.children" style="color: #000"
                  ><i class="el-icon-receiving"></i> {{ node.label }}</span
                >
              </span>
            </el-tree>
          </el-form-item> -->
        </el-form>
      </div>

      <div class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="confirm"
          :loading="loading"
          >保存</el-button
        >
      </div>
    </el-drawer>
    <PersonSelect
      ref="PersonSelect"
      type="radio"
      @select="selectData"
    ></PersonSelect>
  </div>
</template>

<script>
import validate from '@/utils/validate/validate.js'
// import PersonSelect from "./PersonSelect.vue";
import PersonSelect from '@/components/PersonSelect.vue'
export default {
  props: {
    pId: { default: '', type: String, require: true },
    // title: { default: "选择供应商", require: false, type: String },
    type: { default: 'checkBox', require: false, type: String },
  },
  components: { PersonSelect },
  data() {
    return {
      SupplierTypeList: [],
      SupplierQualificationsList: [],
      SupplierClassificationList: [],
      rules: {
        cVenName: [{ required: true, message: '请输入供应商名称' }],
        cVenPerson: [{ required: true, message: '请输入联系人' }],
        SupplierQualificationsList: [
          { required: true, message: '请选择项目资料类型', trigger: 'change' },
        ],
        SupplierClassificationId: [
          { required: true, message: '请选择供应商类型', trigger: 'change' },
        ],
        SupplierTypeList: [
          { required: true, message: '请选择资质资料类型', trigger: 'change' },
        ],

        cVenPhone: [
          {
            validator: validate.validatePhone,
            trigger: 'blur',
            required: true,
            message: '请输入正确的手机号',
          },
        ],
      },
      title: '',
      step: 1,
      TreeData: [],
      EquipmentClassificationIds: [],
      defaultProps: {
        children: 'children',
        label: 'title',
        disabled: () => this.isdisabled(),
      },
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      tableData: [],
      form: {
        cVenCode: '',
        cVenName: '',
        cVenPerson: '',
        cVenPhone: '',
        Remarks: '',
        SupplierQualificationsList: [],
        SupplierTypeList: [],
        SupplierClassificationId: '',
        Address: '',
      },
      dialogVisible: false,
      selectRows: [],
      radioSelect: null,
      searchValue: '',
      dataInfo: [],
      dataObj: {},
      loading: false,
      treeLoading: false,
      isTreeDisabled: false, //是否禁用tree
      SupplierQualificationsAll: false,
      indeterminateA: false,
      indeterminateB: false,
      SupplierTypeListAll: false,
    }
  },
  methods: {
    // 项目资料类型全选事件
    SupplierQualificationsAllChange(val) {
      let SupplierQualificationsList = this.SupplierQualificationsList.map(
        (item) => item.Id
      )
      this.form.SupplierQualificationsList = val
        ? SupplierQualificationsList
        : []
      this.indeterminateA = false
    },
    //项目资料多选事件
    SupplierQualificationsListChange(val) {
      let checkedCount = val.length
      this.SupplierQualificationsAll =
        checkedCount === this.SupplierQualificationsList.length
      this.indeterminateA =
        checkedCount > 0 &&
        checkedCount < this.SupplierQualificationsList.length
    },
    // 资质资料类型全选事件
    SupplierTypeListAllChange(val) {
      let SupplierTypeList = this.SupplierTypeList.map((item) => item.Id)
      this.form.SupplierTypeList = val ? SupplierTypeList : []
      this.indeterminateB = false
    },
    //资质资料多选事件
    SupplierTypeListChange(val) {
      let checkedCount = val.length
      this.SupplierTypeListAll = checkedCount === this.SupplierTypeList.length
      this.indeterminateB =
        checkedCount > 0 && checkedCount < this.SupplierTypeList.length
    },
    isdisabled() {
      if (this.isTreeDisabled) {
        return true
      } else {
        return false
      }
    },
    SupplierClassificationIdChange() {
      this.form.SupplierQualificationsList = []
      this.form.SupplierTypeList = []
      this.SupplierQualificationsAll = false
      this.SupplierTypeListAll = false
    },

    // 下拉
    getSelectList() {
      let arr = [
        'SupplierType',
        'SupplierQualifications',
        'SupplierClassification',
      ]

      arr.forEach((item) => {
        let url = ''
        if (item === 'SupplierClassification') {
          url =
            '/Base_ProjectManage/Project_DictionaryMain/GetSupplierTheDataByDicKey'
        } else {
          url = '/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey'
        }
        this.$http
          .post(url, {
            Condition: 'DicKey',
            Keyword: item,
          })
          .then((res) => {
            if (res.Success)
              this[item + 'List'] = res.Data.DictionaryDetailsList || []
          })
      })
    },
    async getSupplierDataIS(suppierId) {
      let obj = {}
      await this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetSupplierData?ProjectId=${this.pId}&suppierId=${suppierId}`,
          {}
        )
        .then((res) => {
          if (res.Success) {
            obj = res.Data
          }
        })
      return obj
    },
    async selectData(rows) {
      this.form.SupplierQualificationsList = []
      this.form.SupplierTypeList = []
      this.SupplierQualificationsAll = false
      this.SupplierTypeListAll = false
      // let obj = rows[0]
      let obj = await this.getSupplierDataIS(rows[0].Id)
      if (!obj) {
        obj = rows[0]
        this.$set(this.form, 'cVenName', obj.cVenName)
        this.$set(this.form, 'cVenCode', obj.cVenCode)
        this.$set(this.form, 'cVenPerson', obj.cVenPerson)
        this.$set(this.form, 'cVenPhone', obj.cVenPhone)
      } else {
        this.$set(
          obj,
          'SupplierQualificationsList',
          obj.SupplierQualifications
            ? JSON.parse(obj.SupplierQualifications)
            : []
        )
        this.$set(
          obj,
          'SupplierTypeList',
          obj.SupplierType ? JSON.parse(obj.SupplierType) : []
        )

        this.form = obj
        this.EquipmentClassificationIds = obj.EquipmentClassificationIds
          ? JSON.parse(obj.EquipmentClassificationIds)
          : []
        if (this.$refs.tree && this.$refs.tree.setCheckedKeys) {
          this.$refs.tree.setCheckedKeys(this.EquipmentClassificationIds)
        }
      }
    },
    handleIconClick() {
      this.$refs.PersonSelect.open()
    },
    selectable(row) {
      let obj = this.dataInfo.find((item) => {
        return item.cVenName == row.cVenName && item.cVenCode == row.cVenCode
      })
      if (obj) {
        return false
      } else {
        return true
      }
    },
    getTreeData() {
      this.treeLoading = true
      if (window.sessionStorage.getItem('treeData')) {
        let resJson = {
          Data: JSON.parse(window.sessionStorage.getItem('treeData')) || [],
        }
        resJson.Data?.Data.forEach((item) => {
          item.title = '全部'
        })
        // 过滤树数据
        this.TreeData = resJson.Data?.Data || []
        this.treeLoading = false
        return
      }
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjectDevice?ProjectId=' +
            this.pId
        )
        .then((resJson) => {
          this.treeLoading = false
          if (resJson.Success) {
            resJson.Data.Data.forEach((item) => {
              item.title = '全部'
            })

            this.TreeData = resJson.Data?.Data || []
          }
        })
    },
    handleCheckChange() {
      if (this.$refs.tree) {
        this.EquipmentClassificationIds = this.$refs.tree.getCheckedKeys()
      }
    },
    stepData(num) {
      if (num == 2) {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return
          }
          this.step = num
          this.title = '选择设备分类'
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.EquipmentClassificationIds)
          })
        })
        // if (this.type == "checkBox") {
        //   if (this.selectRows.length <= 0) return this.$notify.warning("请选择供应商");
        //   // this.$emit("select", [...this.selectRows]);
        //   // this.dialogVisible = false;
        // } else {
        //   if (this.radioSelect === null) return this.$notify.warning("请选择供应商");
        //   // this.$emit("select", { ...this.tableData[this.radioSelect] });
        //   // this.dialogVisible = false;
        // }
      } else {
        this.step = num
        this.title = '添加供应商'
        this.$nextTick(() => {
          this.selectRows.forEach((item) => {
            this.$refs.multipleTable.toggleRowSelection(item, true)
          })
        })
      }
    },
    SearchData() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    open(title, data, isdisabled = false, DeviceTypeId = '') {
      this.title = title
      this.dataInfo = data
      this.isTreeDisabled = isdisabled
      this.DeviceTypeId = DeviceTypeId
      // this.dataObj = dataObj
      this.form = {
        cVenCode: '',
        cVenName: '',
        cVenPerson: '',
        cVenPhone: '',
        Remarks: '',
        SupplierQualificationsList: [],
        SupplierTypeList: [],
        SupplierClassificationId: '',
        Address: '',
      }
      this.TreeData = []
      this.searchValue = ''
      this.dialogVisible = true
      // this.getDataList();
      this.getSelectList()
      // this.getTreeData()
      this.$nextTick(() => {
        if (
          this.$refs.tree &&
          this.$refs.tree.setCheckedKeys &&
          this.$refs.tree.getCheckedNodes
        ) {
          this.$refs.tree.setCheckedKeys(
            this.$refs.tree.getCheckedNodes(),
            false
          )
        }
        // this.$refs.multipleTable.clearSelection();
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        this.radioSelect = null
        if (data) {
          this.getInfo()
        }

        if (DeviceTypeId) {
          this.$nextTick(() => {
            this.EquipmentClassificationIds = [DeviceTypeId]
            if (this.$refs.tree && this.$refs.tree.setCheckedKeys) {
              this.$refs.tree.setCheckedKeys(this.EquipmentClassificationIds)
            }
          })
        }
      })
    },
    handleSelectionChange(val) {
      this.selectRows = val
    },
    getInfo() {
      this.$http
        .post('/Base_ProjectWork/Base_ProjectSupplier/GetTheData', {
          id: this.dataInfo.Id,
        })
        .then((res) => {
          if (res.Success) {
            this.$set(
              res.Data,
              'SupplierQualificationsList',
              res.Data.SupplierQualifications
                ? JSON.parse(res.Data.SupplierQualifications)
                : []
            )
            this.$set(
              res.Data,
              'SupplierTypeList',
              res.Data.SupplierType ? JSON.parse(res.Data.SupplierType) : []
            )

            this.form = res.Data
            this.EquipmentClassificationIds = res.Data
              .EquipmentClassificationIds
              ? JSON.parse(res.Data.EquipmentClassificationIds)
              : []
            if (this.$refs.tree && this.$refs.tree.setCheckedKeys) {
              this.$refs.tree.setCheckedKeys(this.EquipmentClassificationIds)
            }
          }
        })
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }

        // if (this.EquipmentClassificationIds.length <= 0) {
        //   return this.$notify.warning('请选择设备分类')
        // }
        this.$confirm('是否确认保存?', '提示').then(() => {
          this.loading = true
          this.$http
            .post('/Base_ProjectWork/Base_ProjectSupplier/SaveData', {
              ...this.form,
              ProjectId: this.pId,
              EquipmentClassificationIdList:
                this.EquipmentClassificationIds || [],
            })
            .then((res) => {
              this.loading = false
              if (res.Success) {
                this.$notify.success('保存成功')
                this.dialogVisible = false
                this.$emit('save')
              } else {
                this.$notify.error(res.Msg)
              }
            })
        })
      })

      // if (this.type == "checkBox") {
      //   if (this.selectRows.length <= 0) return this.$notify.warning("请选择供应商");
      //   this.$emit("select", [...this.selectRows]);
      //   this.dialogVisible = false;
      // } else {
      //   if (this.radioSelect === null) return this.$notify.warning("请选择供应商");
      //   this.$emit("select", { ...this.tableData[this.radioSelect] });
      //   this.dialogVisible = false;
      // }
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    getDataList() {
      this.$http
        .post('/Base_BasicData/Base_Supplier/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,

          SortField: 'Id',
          SortType: 'asc',

          Search: {
            Condition: 'cVenName',
            Keyword: this.searchValue,
          },
        })
        .then((res) => {
          if (res.Success) {
            this.tableData = res.Data
            this.pagination.total = res.Total
          }
        })
    },
  },
  computed: {
    SupplierClassificationType() {
      let obj = this.SupplierClassificationList.find((item) => {
        return item.Id === this.form.SupplierClassificationId
      })
      if (obj) {
        return obj.DicValue
      } else {
        return ''
      }
    },
  },
  watch: {
    // title(val) {},
  },
}
</script>

<style lang="scss" scoped>
.mailTable {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  padding-top: 10px;
  box-sizing: border-box;

  .el-table::before {
    z-index: inherit;
  }

  &::-webkit-scrollbar {
    height: 2px;
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条里面小方块 */
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e0e0e0;
  }

  &::-webkit-scrollbar-track {
    /* 滚动条里面轨道 */
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    background: transparent;
  }
}
// ::v-deep .el-tree-node__children {
//   .el-tree-node__children {
//     .el-tree-node {
//       float: left;
//     }
//   }
// }
::v-deep .el-dialog__body {
  padding: 20px;
}
.dialog-footer {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: right;
  padding: 0 20px;
  box-sizing: border-box;
}
::v-deep .el-drawer__header {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
::v-deep .el-input-group__append,
.el-input-group__prepend {
  background-color: #409eff;
  color: #ffff;
  border: 1px solid #409eff;
}
::v-deep .divider {
  margin: 10px 0px;
  font-size: 14px;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000;
}
</style>
